import { Edit, Delete } from "@mui/icons-material";
import React from "react";
import { Tooltip, IconButton, Typography } from "@mui/material";
import { setDefaultData, setWorkerId } from "store/modules/Workers";
import { v4 as uuidv4 } from 'uuid';


export const columns = (setOpen, setMode,setOpenDelete, dispatch) => {
  return [{
    field: `${uuidv4()}`,
    headerName: "Acciones",
    width: 100,
    renderCell: (data) => (
      <React.Fragment>
        <Tooltip title="Editar Trabajador" placement="top">
          <IconButton
            aria-label="edit"
            color="primary"
            onClick={() => { setOpen(true); setMode("PUT"); dispatch(setDefaultData(data.row));dispatch(setWorkerId(data.row.id)) }}
          >
            <Edit />
          </IconButton>
        </Tooltip>
        <Tooltip title="Eliminar Trabajador" placement="top">
          <IconButton
            aria-label="delete"
            color="primary"
            onClick={() => { setOpenDelete(true); setMode("DELETE");dispatch(setWorkerId(data.row.id)) }}
          >
            <Delete />
          </IconButton>
        </Tooltip>

      </React.Fragment>
    ),
  },
  {
    field: "code",
    headerName: "Código",
    width: 100,
  },
  {
    field: "nombre",
    headerName: "Nombre",
    width: 300,
    renderCell: (data) => (
      <Typography>{`${data.row.person.nombre} ${data.row.person.apellidoPaterno} ${data.row.person.apellidoMaterno} `} </Typography>
  )
  },
  {
    field: "rfc",
    headerName: "RFC",
    width: 150,
    renderCell: (data) => (
      <Typography>{`${data.row.person.rfc}`} </Typography>
  )
  },
  {
    field: 'direccion',
    headerName: "Dirección",
    width: 350,
    renderCell: (data) => (
      <Typography>{`${data.row.person.direccion}`} </Typography>
  )
  },
  {
    field: 'department',
    headerName: "Departamento",
    width: 150,
    renderCell: (data) => (
      <Typography>{`${data.row.department.name}`} </Typography>
  )
  },
  {
    field: 'position',
    headerName: "Posicion",
    width: 150,
    renderCell: (data) => (
      <Typography>{`${data.row.position.name}`} </Typography>
  )
  },
  {
    field: 'employmentDate',
    headerName: "Fecha de Inicio",
    width: 150,
    renderCell: (data) => (
      <Typography>{`${data.row.employmentDate ? data.row.employmentDate.split(" ")[0] : ''}`} </Typography>
  )
  },
  {
    field: 'terminationDate',
    headerName: "Fecah de salida",
    width: 150,
    renderCell: (data) => (
      <Typography>{`${data.row.terminationDate || ""}`} </Typography>
  )
  },
  
]
}